import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import LoginPage from "@/pages/LoginPage";
import Dashboard from "@/pages/Dashboard";
import SupplyChain from "@/pages/SupplyChain";
import Procurement from "@/pages/Procurement";

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="font-mono-plex text-xs tracking-widest text-muted-foreground uppercase animate-pulse">
          Verifying access…
        </div>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const PublicOnly = ({ children }) => {
  const { user } = useAuth();
  if (user) return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route
              path="/login"
              element={
                <PublicOnly>
                  <LoginPage />
                </PublicOnly>
              }
            />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/supply-chain"
              element={
                <ProtectedRoute>
                  <Navigate to="/supply-chain/business-review" replace />
                </ProtectedRoute>
              }
            />
            <Route
              path="/supply-chain/:tab"
              element={
                <ProtectedRoute>
                  <SupplyChain />
                </ProtectedRoute>
              }
            />
            <Route
              path="/procurement"
              element={
                <ProtectedRoute>
                  <Navigate to="/procurement/rate-card" replace />
                </ProtectedRoute>
              }
            />
            <Route
              path="/procurement/:tab"
              element={
                <ProtectedRoute>
                  <Procurement />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" theme="light" />
      </AuthProvider>
    </div>
  );
}

export default App;
